// extracted by mini-css-extract-plugin
export var chevron = "_p6-1";
export var clickable = "_p6-0";
export var ruleRow = "_p6-2";